import { Record as record, List } from "immutable";

import {
    construct,
    fields,
    resolve,
    resolveAll
} from "../../../../src/helpers/LinkMapper";
import { CompensationLevel } from "../../../../src/constants/AppConstants";
import { unique } from "../../../../src/helpers/Immutable";

import Station from "../../../../src/records/Station";

export function iBlocksStationToJpStation({
    nlcCode,
    crsCode,
    description,
    nlc,
    crs,
    name
}) {
    return Station.fromJSON({
        nlc: nlcCode || nlc,
        crs: crsCode || crs || "",
        name: (description || name).trim()
    });
}

export class IBlocksRoute extends record({ code: null, description: null }) {
    static fromJSON(json = {}) {
        return construct(IBlocksRoute, json, {
            code: fields.string,
            description: fields.string
        });
    }
}

class IBlocksRouteEligibility extends record({
    compensationLevel: null,
    route: null
}) {
    static fromJSON(json = {}) {
        return construct(IBlocksRouteEligibility, json, {
            compensationLevel: fields.string,
            route: resolve.as(IBlocksRoute)
        });
    }
    isEligible() {
        return (
            this.compensationLevel &&
            this.compensationLevel !== CompensationLevel.NONE
        );
    }
}

export default class IBlocksEligibilityResponse extends record({
    origin: null,
    destination: null,
    routes: new List()
}) {
    static fromJSON(json = {}) {
        return construct(IBlocksEligibilityResponse, json, {
            origin: resolve.with(iBlocksStationToJpStation),
            destination: resolve.with(iBlocksStationToJpStation),
            routes: resolveAll.as(IBlocksRouteEligibility)
        });
    }
    getUniqueLevels() {
        return unique(this.routes.map(r => r.compensationLevel), x => x);
    }
    isAmbiguous() {
        return this.getUniqueLevels().size > 1;
    }
    isEligible(routeCode) {
        const compensationLevel = this.getCompensationLevel(routeCode);
        return (
            this.routes.size > 0 &&
            compensationLevel && compensationLevel !== CompensationLevel.NONE
        );
    }
    isIneligible(routeCode) {
        const compensationLevel = this.getCompensationLevel(routeCode);
        return (
            this.routes.size === 0 ||
            (compensationLevel && compensationLevel === CompensationLevel.NONE)
        );
    }
    isLevel1(routeCode) {
        const compensationLevel = this.getCompensationLevel(routeCode);
        return (
            compensationLevel && compensationLevel === CompensationLevel.LEVEL1
        );
    }
    isLevel2(routeCode) {
        const compensationLevel = this.getCompensationLevel(routeCode);
        return (
            compensationLevel && compensationLevel === CompensationLevel.LEVEL2
        );
    }
    getCompensationLevel(routeCode = null) {
        if (routeCode) {
            const { compensationLevel } = this.routes.find(
                r => r.route.code === routeCode
            );
            return compensationLevel;
        } else {
            const uniqueLevels = this.getUniqueLevels();
            if (uniqueLevels.size === 1) {
                return uniqueLevels.get(0);
            }
        }
        return null;
    }
}
